export default "__VITE_ASSET__3a826a7a__"